import React from "react";
import cx from "classnames";
// import PropTypes from 'prop-types'
import { TableBookingReserveStyled } from "./styled";
import { Inputs, Displays,  } from "components";

const TableBookingReserve = ({ theme_standard }) => {
  const customClass = cx({
    theme_standard: theme_standard,
  });
  return (
    <TableBookingReserveStyled className={customClass}>
      <div className="table_scroll_x">
      <table className="table_info">
        <tr>
          <th className="checkbox_header">เซ็ทเป็นไม่ว่าง</th>
          <th className="table_header">SUN 1</th>
          <th className="table_header">MON 2</th>
          <th className="table_header">TUE 3</th>
          <th className="table_header">WED 4</th>
          <th className="table_header">THU 5</th>
          <th className="table_header">FRI 6</th>
          <th className="table_header">SAT 7</th>
        </tr>
        <tr>
          <td className="checkbox">
            <Inputs.InputCheckBox label="09:00 - 10:00" />
          </td>
          <td className="table_detail_gray"></td>
          <td className="table_detail_gray"></td>
          <td className="table_detail_gray"></td>
          <td className="table_detail_gray"></td>
          <td className="table_detail_gray"></td>
          <td className="table_detail_gray"></td>
          <td className="table_detail_gray"></td>
        </tr>
        <tr>
          <td className="checkbox">
            <Inputs.InputCheckBox label="10:00 - 11:00" />
          </td>
          <td className="table_detail"></td>
          <td className="table_detail"></td>
          <td className="table_detail"></td>
          <td className="table_detail">
            <Displays.EventItem
              name="ทิวาพร"
              event="Event Name"
              color="#2EB117"
            />
          </td>
          <td className="table_detail"></td>
          <td className="table_detail"></td>
          <td className="table_detail">
            <Displays.EventItem
              name="ทิวาพร"
              event="Event Name"
              color="#2EB117"
            />
          </td>
        </tr>
        <tr>
          <td className="checkbox">
            <Inputs.InputCheckBox label="11:00 - 12:00" />
          </td>
          <td className="table_detail_gray"></td>
          <td className="table_detail_gray"></td>
          <td className="table_detail_gray"></td>
          <td className="table_detail_gray"></td>
          <td className="table_detail_gray"></td>
          <td className="table_detail_gray"></td>
          <td className="table_detail_gray"></td>
        </tr>
        <tr>
          <td className="checkbox">
            <Inputs.InputCheckBox label="12:00 - 13:00" />
          </td>
          <td className="table_detail"></td>
          <td className="table_detail"></td>
          <td className="table_detail"></td>
          <td className="table_detail"></td>
          <td className="table_detail"></td>
          <td className="table_detail"></td>
          <td className="table_detail"></td>
        </tr>
        <tr>
          <td className="checkbox">
            <Inputs.InputCheckBox label="13:00 - 14:00" />
          </td>
          <td className="table_detail_gray">
            <Displays.EventItem
              name="ทิวาพร"
              event="Event Name"
              color="#2EB117"
            />
          </td>
          <td className="table_detail_gray"></td>
          <td className="table_detail_gray"></td>
          <td className="table_detail_gray"></td>
          <td className="table_detail_gray"></td>
          <td className="table_detail_gray"></td>
          <td className="table_detail_gray"></td>
        </tr>
        <tr>
          <td className="checkbox">
            <Inputs.InputCheckBox label="14:00 - 15:00" />
          </td>
          <td className="table_detail"></td>
          <td className="table_detail"></td>
          <td className="table_detail"></td>
          <td className="table_detail"></td>
          <td className="table_detail"></td>
          <td className="table_detail"></td>
          <td className="table_detail"></td>
        </tr>
        <tr>
          <td className="checkbox">
            <Inputs.InputCheckBox label="15:00 - 16:00" />
          </td>
          <td className="table_detail_gray"></td>
          <td className="table_detail_gray"></td>
          <td className="table_detail_gray"></td>
          <td className="table_detail_gray"></td>
          <td className="table_detail_gray"></td>
          <td className="table_detail_gray"></td>
          <td className="table_detail_gray"></td>
        </tr>
        <tr>
          <td className="checkbox">
            <Inputs.InputCheckBox label="16:00 - 17:00" />
          </td>
          <td className="table_detail"></td>
          <td className="table_detail"></td>
          <td className="table_detail"></td>
          <td className="table_detail"></td>
          <td className="table_detail"></td>
          <td className="table_detail"></td>
          <td className="table_detail"></td>
        </tr>
        <tr>
          <td className="checkbox">
            <Inputs.InputCheckBox label="17:00 - 18:00" />
          </td>
          <td className="table_detail_gray"></td>
          <td className="table_detail_gray"></td>
          <td className="table_detail_gray"></td>
          <td className="table_detail_gray"></td>
          <td className="table_detail_gray"></td>
          <td className="table_detail_gray"></td>
          <td className="table_detail_gray"></td>
        </tr>
      </table>
      </div>

    </TableBookingReserveStyled>
  );
};

TableBookingReserve.propTypes = {};

export default TableBookingReserve;
